import { Button, Tooltip, Typography } from 'antd';
import type { ColumnType, ColumnsType } from 'antd/es/table';
import { EyeOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';

import { Customer, User } from '../../../../api';
import Table from '../../../../components/general/table';
import { ExportExcelProps } from '../../../../helpers/excel';
import UserForm from '../detail';
import { ExportPdfProps } from '../../../../helpers/pdf';

const label = 'cliente';
const route = '/customers';
const titlePdf = 'Reporte de clientes';
const scrollTable = 1000;

type GenerateTableColumnProps = {
  getColumnSearchProps: (propName: string) => ColumnType<User>;
  showModal: (type: string, id: number | null) => void;
  handleDelete: (id: number) => void;
};

const CustomersList = () => {
  const { Text } = Typography;

  const generateTableColumns: (
    props: GenerateTableColumnProps
  ) => ColumnsType<User> = (props) => {
    const { getColumnSearchProps, showModal, handleDelete } = props;

    return [
      {
        title: 'Nombre',
        width: 190,
        dataIndex: 'company_name',
        key: 'company_name',
        ...getColumnSearchProps('company_name'),
        render: (company_name) => (
          <>
            {company_name && (
              <Text>
                {company_name.charAt(0).toUpperCase() + company_name.slice(1)}
              </Text>
            )}
          </>
        ),
      },
      {
        title: 'Teléfono',
        width: 80,
        dataIndex: 'phone',
        key: 'phone',
        ...getColumnSearchProps('phone'),
        render: (phone) => (
          <Text>{phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')}</Text>
        ),
      },
      {
        title: 'Correo electrónico',
        width: 150,
        dataIndex: 'email',
        key: 'email',
        ...getColumnSearchProps('email'),
        render: (email) => <Text>{email.toLowerCase()}</Text>,
      },
      {
        title: 'Agente',
        width: 100,
        dataIndex: 'sales_agent_name',
        key: 'sales_agent_name',
        ...getColumnSearchProps('sales_agent_name'),
      },
      {
        title: 'Acciones',
        key: 'sup',
        fixed: 'right',
        width: 80,
        align: 'center',
        render: (user) => (
          <>
            <Tooltip title="Ver más información">
              <Button
                type="primary"
                ghost
                shape="default"
                size="small"
                icon={<EyeOutlined />}
                onClick={() => showModal('watch', user.id)}
              />
            </Tooltip>
            <Tooltip title="Editar">
              <Button
                style={{
                  marginLeft: 10,
                  backgroundColor: '#1b4289',
                  borderColor: '#1b4289',
                }}
                type="primary"
                shape="default"
                size="small"
                icon={<EditOutlined />}
                onClick={() => showModal('edit', user.id)}
              />
            </Tooltip>
            <Tooltip title="Eliminar">
              <Button
                style={{
                  marginLeft: 10,
                  backgroundColor: '#e63241',
                  borderColor: '#cf1322',
                }}
                type="primary"
                shape="default"
                size="small"
                icon={<DeleteOutlined />}
                onClick={() => handleDelete(user.id)}
              />
            </Tooltip>
          </>
        ),
      },
    ];
  };

  const generateExportExcelProps: () => ExportExcelProps = () => ({
    fileName: 'Reporte_Clientes',
    sheetName: 'Clientes',
    tableName: 'Tabla de clientes',
    columnNames: [
      {
        label: 'Nombre',
        key: 'company_name',
        format: (val) => val.charAt(0).toUpperCase() + val.slice(1),
      },
      {
        label: 'Teléfono',
        key: 'phone',
        format: (val) => val.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'),
      },
      {
        label: 'Correo electrónico',
        key: 'email',
        format: (val) => val.toLowerCase(),
      },
    ],
  });

  const pdfColumns: ExportPdfProps[] = [
    {
      header: 'Nombre',
      key: 'company_name',
      format: (val) => val.charAt(0).toUpperCase() + val.slice(1),
    },
    {
      header: 'Teléfono',
      key: 'phone',
      format: (val) => val.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'),
    },
    {
      header: 'Correo electrónico',
      key: 'email',
      format: (val) => val.toLowerCase(),
    },
  ];

  const userTableProps = {
    label,
    route,
    generateTableColumns,
    generateExportExcelProps,
    detailForm: UserForm,
    pdfColumns,
    titlePdf,
    scrollTable,
  };
  const UsersTable = Table<Customer>(userTableProps);

  return UsersTable;
};

export default CustomersList;
